import React, { useEffect, useState } from 'react';
// Assure-toi que les chemins d'images sont corrects
import Excel from '../img/2.png';
import Pizza from '../img/3.png';
import Banniere from '../img/banniere.jpg'; // Ton image de fond pour le footer
import Inmyscan from '../img/inmyscan.png'; // Ton image de fond pour le footer

const Projects = () => {
  // --- LOGIQUE PARALLAXE ---
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    // On écoute le scroll
    window.addEventListener("scroll", handleScroll);
    // On nettoie l'écouteur quand le composant est détruit
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // --- FONCTION POUR LES COULEURS DES TAGS ---
  const getTechStyle = (tech) => {
    const t = tech.toLowerCase();
    
    // Java & JavaFX -> Orange subtil
    if (t.includes('java')) return "bg-orange-500/10 text-orange-500 border-orange-500/20";
    
    // Symfony, PHP, Twig -> Indigo/Violet
    if (t.includes('symfony') || t.includes('php') || t.includes('twig')) return "bg-indigo-500/10 text-indigo-400 border-indigo-500/20";
    
    // React, Turbo -> Bleu Cyan
    if (t.includes('react') || t.includes('turbo')) return "bg-cyan-500/10 text-cyan-400 border-cyan-500/20";
    
    // SQL, Data, Postgres -> Émeraude/Vert
    if (t.includes('sql') || t.includes('postgre')) return "bg-emerald-500/10 text-emerald-400 border-emerald-500/20";
    
    // C, C#, .NET -> Slate/Gris bleuté
    // Concepts (MVC, Algo, Sérialisation) -> Rose
    if (t.includes('mvc') || t.includes('algo') || t.includes('séria')) return "bg-rose-500/10 text-rose-400 border-rose-500/20";
    
    // API, REST -> Ambre/Jaune
    if (t.includes('api') || t.includes('rest')) return "bg-slate-500/10 text-slate-400 border-slate-500/20";

    // Défaut -> Violet Discord
    return "bg-[#5865F2]/10 text-[#5865F2] border-[#5865F2]/20";
  };

  const projects = [
    {
      title: "Cacalzone App",
      category: "L3 Conception Développement d'Applications",
      desc: "Application de gestion sous architecture MVC avec interface JavaFX et persistance via sérialisation binaire pour assurer une gestion autonome sans SGBD.",
      tech: ["Java", "JavaFX", "MVC", "Sérialisation"],
      image: Pizza,
      year: "2026",
      githubLink: "https://github.com/JeMeSuisPerdu/Cacalzone"
    },
    {
      title: "Tableur 'Monoplan'",
      category: "Projet Universitaire L3",
      desc: "Clone d'Excel développé en C. Moteur de calcul basé sur la Notation Polonaise Inversée (RPN), interface GTK et gestion manuelle de la mémoire.",
      tech: ["C", "GTK", "Glade", "Algorithmique"],
      image: Excel,
      year: "2025",
      githubLink: "https://github.com/JeMeSuisPerdu/Monoplan"
    },
    {
      title: "InMySac",
      category: "Projet Personnel",
      desc: "Plateforme de troc type Vinted incluant un algorithme de matching pour les échanges, une messagerie chiffrée et une gestion des utilisateurs sous Symfony 6.",
      tech: ["Symfony 6", "React", "MySQL", "Turbo"],
      image: "https://imageprojetsanis.netlify.app/images/accueill.png",
      year: "2024",
      githubLink: "https://github.com/JeMeSuisPerdu/immo"
    },
    {
      title: "In-MyScan",
      category: "Projet Personnel",
      desc: "InMyScan est une plateforme de streaming développée avec Symfony, offrant une interface propre et légale pour découvrir des films, séries, anime et manga sans héberger de contenu illégal.",
      tech: ["Symfony 6", "Twig", "PHP", "PostgreSql"],
      image: Inmyscan,
      year: "2024",
      githubLink: "https://github.com/JeMeSuisPerdu/inmyscan"
    },
    {
      title: "Mediatek Formation",
      category: "BTS SIO SLAM",
      desc: "Application web de gestion de vidéos de formation avec gestion sécurisée du back-office et documentation technique exhaustive.",
      tech: ["Symfony", "MySQL", "PHP"],
      videoUrl: "https://www.youtube.com/embed/wisN8AKT4Sc",
      year: "2024",
      githubLink: "https://github.com/JeMeSuisPerdu/Mediatek-Formation"
    },
    {
      title: "Mediatek Document",
      category: "BTS SIO SLAM",
      desc: "Évolution d'une solution desktop en C# communiquant avec une API REST PHP pour la gestion documentaire.",
      tech: ["C#", "API REST", "PHP", "MySQL"],
      videoUrl: "https://www.youtube.com/embed/AbumNS5a96M",
      year: "2024",
      githubLink: "https://github.com/JeMeSuisPerdu/Mediatek-Document"
    }
  ];

  return (
    <div className="pt-24 pb-0 overflow-x-hidden">
      
      {/* HEADER */}
      <section className="max-w-6xl mx-auto px-6 py-20 relative">
        <h2 className="text-8xl font-black italic tracking-tighter uppercase opacity-[0.07] dark:opacity-[0.05] absolute -translate-y-16 left-0 select-none">
          Portfolio
        </h2>
        <div className="relative z-10">
          <h2 className="text-5xl font-black tracking-tight mb-4">
            Réalisations & <br/>
            <span className="text-neon-purple underline decoration-discord-blurple/30">Ingénierie</span>
          </h2>
          <p className="text-gray-500 dark:text-gray-400 max-w-xl text-lg">
            De la gestion mémoire en C au déploiement d'écosystèmes Web modernes.
          </p>
        </div>
      </section>

      {/* SECTIONS ALTERNÉES */}
      <div className="space-y-40 mb-32">
        {projects.map((p, i) => (
          <section key={i} className="w-full relative">
            
            {/* LE CHIFFRE DE FOND GÉANT (PARALLAXE + COULEUR DISCORD) */}
            <div 
              className={`absolute top-0 w-full flex ${i % 2 === 0 ? 'justify-end pr-10' : 'justify-start pl-10'} pointer-events-none z-0 hidden md:flex`}
              style={{ 
                // Effet Parallaxe : Le chiffre bouge lentement (vitesse * 0.1)
                transform: `translateY(${(scrollY - (i * 400)) * 0.2}px)` 
              }}
            >
              {/* Couleur hexadécimale de Discord #5865F2 */}
              <span className="text-[15rem] font-black text-[#5865F2] opacity-[0.15] select-none leading-none">
                0{i + 1}
              </span>
            </div>

            <div className={`max-w-6xl mx-auto px-6 flex flex-col ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-16 relative z-10`}>
              
              {/* VISUEL */}
              <div className="w-full md:w-1/2 relative group">
                <div className="absolute -inset-4 bg-gradient-to-r from-discord-blurple/20 to-neon-purple/20 rounded-[2.5rem] opacity-0 group-hover:opacity-100 blur-2xl transition-opacity duration-500"></div>
                
                <div className="relative overflow-hidden rounded-[2rem] border border-gray-100 dark:border-white/10 shadow-2xl aspect-video bg-gray-50 dark:bg-discord-gray">
                  {p.videoUrl ? (
                    <iframe className="w-full h-full" src={p.videoUrl} title={p.title} allowFullScreen></iframe>
                  ) : (
                    // MODIFICATION ICI : L'image est maintenant un lien
                    <a href={p.githubLink} target="_blank" rel="noopener noreferrer" className="block w-full h-full cursor-pointer">
                        <img 
                          src={p.image} 
                          alt={p.title} 
                          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" 
                        />
                        {/* Petit overlay optionnel au survol pour indiquer que c'est cliquable */}
                        <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center pointer-events-none">
                            <span className="bg-black/50 text-white px-4 py-2 rounded-full text-sm font-bold backdrop-blur-sm">Voir le code ↗</span>
                        </div>
                    </a>
                  )}
                </div>
              </div>

              {/* TEXTE */}
              <div className="w-full md:w-1/2 space-y-6">
                <div className="flex items-center gap-4">
                  <span className="text-neon-purple font-mono font-bold">{p.year}</span>
                  <div className="h-[1px] w-12 bg-gray-200 dark:bg-white/20"></div>
                  <span className="text-[10px] uppercase tracking-[0.2em] font-bold opacity-50">{p.category}</span>
                </div>
                
                {/* Le titre est aussi un lien vers le repo pour l'UX */}
                <a href={p.githubLink} target="_blank" rel="noopener noreferrer" className="block w-fit">
                    <h3 className="text-4xl font-black tracking-tight italic group-hover:text-neon-purple transition-colors hover:underline decoration-neon-purple decoration-4 underline-offset-4">
                    {p.title}
                    </h3>
                </a>
                
                <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed font-medium">
                  {p.desc}
                </p>
                
                <div className="flex flex-wrap gap-3 pt-4">
                  {p.tech.map((t, idx) => (
                    // ICI J'APPELLE LA FONCTION getTechStyle POUR LA COULEUR DYNAMIQUE
                    <span 
                      key={idx} 
                      className={`px-4 py-1.5 rounded-xl font-mono text-xs border shadow-sm ${getTechStyle(t)}`}
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>

            </div>
          </section>
        ))}
      </div>

      {/* BANNIÈRE GITHUB IMMERSIVE (FULL WIDTH) */}
      <section className="w-full relative h-[450px] flex items-center justify-center overflow-hidden border-t border-white/5">
        
        {/* IMAGE DE FOND (Bannière) */}
        <div 
          className="absolute inset-0 z-0 scale-105"
          style={{
            backgroundImage: `url(${Banniere})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'grayscale(15%) brightness(0.9)',
          }}
        ></div>
        
        {/* OVERLAY DÉGRADÉ VIOLET SUBTIL */}
        <div className="absolute inset-0 bg-gradient-to-t from-discord-gray/90 via-discord-gray/50 to-transparent z-10"></div>

        {/* CONTENU */}
        <div className="relative z-20 max-w-5xl w-full px-6">
          <a href="https://github.com/JeMeSuisPerdu/" target="_blank" rel="noopener noreferrer" className="group block">
            <div className="bg-white/5 backdrop-blur-md border border-white/10 p-10 rounded-[2.5rem] flex flex-col md:flex-row items-center justify-between gap-8 transition-all duration-300 group-hover:bg-white/10 group-hover:border-neon-purple/50 shadow-2xl">
              
              <div className="flex items-center gap-8 text-left">
                <span className="text-7xl group-hover:rotate-12 transition-transform duration-500 drop-shadow-lg">🐙</span>
                <div>
                  <h3 className="text-3xl font-black text-white tracking-tight uppercase italic drop-shadow-md">
                    GitHub Activity
                  </h3>
                  <p className="text-gray-300 italic text-lg mt-2 font-medium">
                    Code source, algorithmes et contributions quotidiennes.
                  </p>
                </div>
              </div>
              
              <div className="bg-neon-purple text-white px-10 py-4 rounded-full font-bold text-lg shadow-xl shadow-neon-purple/40 hover:scale-105 transition-all active:scale-95 whitespace-nowrap">
                Voir le profil
              </div>

            </div>
          </a>
        </div>
      </section>

    </div>
  );
};

export default Projects;